.single-integration-banner {
  overflow: hidden;
  position: relative;
  display: flex;
  border-radius: 4px;
  border: 1px solid;
  border-color: var(--chart-103-pressed);
  background-color: var(--white-layout-302-level-1-elevation);

  .header-title {
    font-weight: 500;
    line-height: 33px;
    color: var(--body-text-arrows-400);
  }

  .image-container {
    width: 40%;
    position: relative;

    > * {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      opacity: 0.6;
    }

    .icon {
      position: absolute;
      display: flex;
      background-color: var(--white-layout-302-level-1-elevation);
      align-items: center;
      justify-content: center;
      width: calc(16 * var(--spacer));
      height: calc(16 * var(--spacer));
      border: 1px solid var(--chart-101-pressed-dividers);
      border-radius: 50%;
    }
  }

  .data-container {
    width: 60%;
    padding: calc(var(--spacer) * 7) calc(var(--spacer) * 4.5) calc(var(--spacer) * 7) calc(var(--spacer) * 6);
  }

  gz-icon::part(svgIcon) {
    fill: var(--blue-layout-403-primary);
  }
}
